import { render } from "./TwoFactorChallenge.vue?vue&type=template&id=bc3770b2"
import script from "./TwoFactorChallenge.vue?vue&type=script&lang=js"
export * from "./TwoFactorChallenge.vue?vue&type=script&lang=js"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__